export const SIX_DIGITS_REGEX = /^\d{6}$/;
